<template>
	<div>
		<vx-card
			v-if="rows.length === 0"
			title="Selecionar o período:"
		>
			<form data-vv-scope="step-1" @submit.prevent="validForm">
				<div class="vx-row">
					<div class="vx-col md:w-1/2 w-full mt-5">
						Período Início
						<Datepicker
							v-model="dateStart"
							name="dateStart"
							:language="ptBR"
						></Datepicker>
					</div>
					<div class="vx-col md:w-1/2 w-full mt-5">
						Período Fim
						<Datepicker
							v-model="dateEnd"
							name="dateEnd"
							:language="ptBR"
						></Datepicker>
					</div>
				</div>
				<div class="flex flex-row-reverse mt-5">
					<vs-button button="submit">Enviar</vs-button>
				</div>
			</form>
		</vx-card>

		<vx-card v-else :title="'Conta Universal'">
			<div class="mb-5 flex flex-row justify-between">
				<div class="w-1/2">
					<p>
						<strong>Período:</strong>
						{{ format(dateStart, 'dd/MM/yyyy') }} -
						{{ format(dateEnd, 'dd/MM/yyyy') }}
					</p>
					<div v-if="!loadingBalance">
						<p>
							<strong>Saldo inicial:</strong>
							R$ {{ initialValue }}
						</p>
					</div>
					<div v-if="!loadingBalance">
						<p>
							<strong>Saldo final:</strong>
							R$ {{ finalValue }}
						</p>
					</div>
					<div v-if="loadingBalance" class="flex mt-3 flex-start">
						<clip-loader
							v-if="loadingBalance"
							:loading="loadingBalance"
						></clip-loader>
					</div>
				</div>
				<div class="w-full mr-4 mt-5 flex justify-end items-center">
					<div class="flex flex-col items-center">
						<span class="font-bold mb-2 text-sm"
							>Exportar Extrato</span
						>
						<div>
							<vs-dropdown
								vs-custom-content
								vs-trigger-click
								class="cursor-pointer"
							>
								<a class="a-icon" href="#">
									<vs-button
										color="primary"
										type="filled"
										icon-pack="feather"
										icon="icon-download"
										size="small"
										:disabled="loadingBalance"
										@click="() => {}"
										>Export
									</vs-button>
								</a>

								<vs-dropdown-menu class="vx-navbar-dropdown">
									<ul style="min-width: 7rem">
										<li
											class="flex flex-row items-center py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
											@click="() => getAllRows('PDF')"
										>
											<vs-icon
												class=""
												icon-pack="feather"
												icon="icon-download"
											></vs-icon>
											<span class="ml-2">{{
												loadingPdf ? '' : 'PDF'
											}}</span>
											<clip-loader
												v-if="loadingPdf"
												size="12px"
												color="#2c2c2c"
												class="ml-3"
												:loading="loadingPdf"
											></clip-loader>
										</li>
										<li
											class="flex flex-row items-center py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
											@click="() => getAllRows('Excel')"
										>
											<vs-icon
												class=""
												icon-pack="feather"
												icon="icon-download"
											></vs-icon>
											<span class="ml-2">{{
												loadingExcel ? '' : 'Excel'
											}}</span>
											<clip-loader
												v-if="loadingExcel"
												size="12px"
												color="#2c2c2c"
												class="ml-3"
												:loading="loadingExcel"
											></clip-loader>
										</li>
									</ul>
								</vs-dropdown-menu>
							</vs-dropdown>
						</div>
					</div>
				</div>
			</div>
			<vue-good-table
				mode="remote"
				:pagination-options="{
					enabled: true,
					nextLabel: 'próximo',
					prevLabel: 'anterior',
					rowsPerPageLabel: 'Registros por páginas',
					ofLabel: 'de',
					pageLabel: 'página', // for 'pages' mode
					dropdownAllowAll: false,
					mode: 'pages',
				}"
				:sort-options="{
					enabled: false,
				}"
				:total-rows="totalRecords"
				:columns="columns"
				:rows="rows"
				:is-loading.sync="isLoading"
				@on-select-all="onSelectAll"
				@on-selected-rows-change="selectionChanged"
				@on-page-change="onPageChange"
				@on-per-page-change="onPerPageChange"
			>
				<div slot="emptystate">Nenhum registro encontrado.</div>
				<template slot="table-row" slot-scope="props">
					<span v-if="props.column.field === 'value'">
						<span
							v-if="props.row.type === 'debit'"
							style="color: red"
							>{{ (props.row.value / 100) | currency }}</span
						>
						<span v-if="props.row.type === 'credit'">{{
							(props.row.value / 100) | currency
						}}</span>
					</span>
					<span v-else-if="props.column.field == 'date'">
						<span>{{ formatDateAndTime(props.row.date) }}</span>
					</span>

					<span v-else-if="props.column.field == 'type'">
						<span>{{ statusTranslate(props.row.type) }}</span>
					</span>

					<span v-else-if="props.column.field == 'effective_date'">
						<span>{{ formatDateAndTime(props.row.effective_date) }}</span>
					</span>

					<span v-else>
						{{ props.formattedRow[props.column.field] }}
					</span>
					<span v-if="props.column.field == 'action'">
						<div class="flex items-center justify-center w-full">
							<vs-button
								:disabled="
									props.row.detail.indexOf('Tarifa') > -1
								"
								color="primary"
								icon="visibility"
								@click="redirectTransfer(props.row)"
							/>
						</div>
					</span>
				</template>
			</vue-good-table>

			<div class="w-full mr-4 mt-5 flex justify-between items-center">
				<div>
					<vs-button
						class="mt-5"
						@click="
							() => {
								rows = [];
								loading = false;
								alldatas = null;
							}
						"
						>Voltar</vs-button
					>
				</div>
			</div>
		</vx-card>
		<vx-card v-if="notResult" class="mt-8">
			<div class="w-full vx-row justify-center font-bold">
				Nenhum registro encontrado
			</div>
		</vx-card>
	</div>
</template>

<script>
import { mask } from 'vue-the-mask';
import { format, addDays, startOfDay } from 'date-fns';
import { ptBR as PTBr } from 'vuejs-datepicker/dist/locale';
import Datepicker from 'vuejs-datepicker';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import {
	formatDate,
	formatMoney,
	statusTranslate,
	formatDateAndTime,
	gerarDocPdf,
	gerarTablePdf,
	gerarDocInfo,
	salvarDocPdf,
	getTimestamp,
	formatAmericanMoney,
} from '../utils';

import { excelGenerator } from '../utils/excelGenerator'
import { gerarOfx } from '../utils/ofx';
import { PaymentService } from '@/services/payment';

export default {
	directives: { mask },
	components: { ClipLoader, Datepicker },
	data() {
		return {
			title: process.env.VUE_APP_TITLE,
			type: 'Beneficiários',
			phone: '',
			rows: [],
			columns: [
				{
					label: 'Data',
					field: 'date',
				},
				{
					label: 'Origem / Destino',
					field: 'origin_destiny',
				},
				{
					label: 'Tipo',
					field: 'type'
				},
				{
					label: 'Descrição',
					field: 'detail',
				},
				{
					label: 'Valor',
					field: 'value',
				},
				{
					label: 'Data de Efetivação',
					field: 'effective_date',
				},
			],
			allLimit: 0,
			page: 1,
			isLoading: false,
			pagePerPage: 10,
			dateStart: null,
			dateEnd: new Date(),
			ptBR: PTBr,
			configTodateTimePicker: {
				minDate: null,
			},
			account: JSON.parse(sessionStorage.getItem('account')),
			notResult: false,
			loading: false,
			loadingBalance: false,
			alldatas: null,
			initialValue: 0,
			finalValue: 0,
			total: 0,
			loadingExcel: false,
			loadingPdf: false,
			loadingOfx: false,
		};
	},
	methods: {
		format,
		formatDate,
        formatDateAndTime,
        statusTranslate,
		formatMoney,
		gerarOfx,
		onPageChange(params) {
			this.page = params.currentPage;
			this.formSubmitted();
		},
		onSelectAll(params) {
			this.selectedRows = params.selectedRows;
		},
		selectionChanged(params) {
			this.selectedRows = params.selectedRows;
		},
		onPerPageChange(params) {
			this.pagePerPage = params.currentPerPage;
			this.formSubmitted();
		},
		async formSubmitted() {

			this.$vs.loading();
			try {
				const filters = [];

				filters.push({
					field: 'date',
					operator: 'gte',
					value: startOfDay(this.dateStart),
					timezone: getTimestamp(),
				});

				filters.push({
					field: 'date',
					operator: 'lt',
					value: addDays(startOfDay(this.dateEnd), 1),
					timezone: getTimestamp(),
				});

				const { data } = await this.$http.get(
                    '/payment/universal-account/statement',
					{
						params: {
							page: this.page,
							limit: this.pagePerPage,
							orders: {
								date: 'desc',
							},
							filters,
						},
					}
				);
				this.notResult = data.data.length === 0;
				this.allLimit = data.meta.total;
				this.totalRecords = data.meta.total;
				this.rows = data.data;
				this.getBalance();
			} catch (error) {
				console.log(error);
				console.log(error.response);
			} finally {
				this.$vs.loading.close();
			}
		},
		async getBalance() {
			this.loadingBalance = true;
			const addDay = addDays(this.dateEnd, 1)
			const startDate = this.dateStart.toLocaleDateString("zh-Hans-CN",{year:"numeric",month:"2-digit", day:"2-digit"})
			const finalDate = addDay.toLocaleDateString("zh-Hans-CN",{year:"numeric",month:"2-digit", day:"2-digit"}) 
			await this.$http
				.get(`/payment/transaction/universal_account_balance`, {
					params: {
						started_at: startDate.replace(new RegExp("/", 'g'),"-" ),
						finished_at: finalDate.replace(new RegExp("/", 'g'),"-"),
						timezone: getTimestamp(),
					},
				})
				.then(data => {
					this.initialValue = formatMoney(data.data.before);
					this.intFinalValue = data.data.after
					this.finalValue = formatMoney(data.data.after);
					this.unformattedValue = data.data.after;
					this.total = formatMoney(data.data.total);
					this.loadingBalance = false;
				})
				.catch(err => {
					console.log(err);
					this.loadingBalance = false;
				});
		},
		validForm() {
			return new Promise((resolve /* reject */) => {
				this.$validator.validateAll('step-1').then(result => {
					if (result) {
						if (this.dateStart) {
							resolve(true);
							this.formSubmitted();
						} else {
							this.$vs.notify({
								text: 'Por favor selecione o Período de Início',
								iconPack: 'feather',
								icon: 'icon-alert-circle',
								color: 'warning',
							});
						}
					}
				});
			});
		},
		onToChange(selectedDates, dateStr) {
			this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
		},
		async redirectTransfer(transaction) {
			PaymentService.openReceipt(transaction);
		},
		async getAllRows(type) {
			if (
				this.loadingPdf === true ||
				this.loadingExcel === true ||
				this.loadingOfx === true
			) {
				return;
			}

			if (type === 'PDF') {
				this.loadingPdf = true;
			} else if (type === 'Excel') {
				this.loadingExcel = true;
			} else if (type === 'OFX') {
				this.loadingOfx = true;
			}

			const filters = [];

			filters.push({
				field: 'date',
				operator: 'gte',
				value: startOfDay(this.dateStart),
				timezone: getTimestamp(),
			});

			filters.push({
				field: 'date',
				operator: 'lt',
				value: addDays(startOfDay(this.dateEnd), 1),
				timezone: getTimestamp(),
			});
			await this.$http
				.get('/payment/universal-account/statement', {
					params: {
						page: 1,
						limit: this.allLimit,
						orders: {
							date: 'asc',
						},
						filters,
					},
				})
				.then(data => {
                    this.transactionData = data.data.data.map(row => {
						let transactionRows = {};
						transactionRows.date = formatDateAndTime(row.date);
						transactionRows.origin_destiny = row.origin_destiny;
						transactionRows.type = statusTranslate(row.type);
						transactionRows.detail = row.detail;
						transactionRows.value_pdf =
							row.type === 'credit'
								? `R$ ${formatMoney(row.value)}`
								: `- R$ ${formatMoney(row.value)}`;
						transactionRows.value_excel = parseFloat(formatAmericanMoney(row.value));
						transactionRows.effective_date = formatDateAndTime(row.effective_date);
						return transactionRows;
					});
					if (type === 'PDF') {
						this.gerarPDF();
					} else if (type === 'Excel') {
						this.gerarExcel();
					} else if (type === 'OFX') {
						this.gerarOfx(data.data.data, {
							...this.account,
							dateStart: this.dateStart,
							dateEnd: this.dateEnd,
							ledgerAmount: this.unformattedValue,
						});
						this.loadingOfx = false;
					}
				})
				.catch(err => {
					console.log(err);
					this.loadingExcel = false;
					this.loadingPdf = false;
				});
        },
        gerarPDF() {
			var columns = [
				{ title: 'Data', dataKey: 'date' },
				{ title: 'Origem / Destino', dataKey: 'origin_destiny' },
				{ title: 'Tipo', dataKey: 'type' },
				{ title: 'Descrição', dataKey: 'detail' },
				{ title: 'Valor', dataKey: 'value_pdf' },
				{ title: 'Data de Efetivação', dataKey: 'effective_date' },
			];

			let body =  this.transactionData
			
			var columnsBalance = [
				{ title: 'Title I', dataKey: 'text' },
				{ title: 'Title II', dataKey: 'valor' },
			];
			
			let orientacao = 'p';
			

			let doc = gerarDocPdf({ orientacao });

			doc = gerarTablePdf({
				doc,
				showHead: 'never',
				body: [
					{
						text: `Conta Universal no Período de: ${format(
							Date.parse(this.dateStart),
							'dd/MM/yyyy'
						)} à ${format(Date.parse(this.dateEnd), 'dd/MM/yyyy')}`,
					},
				],
			});

			doc = gerarTablePdf({
				doc,
				showHead: 'never',
				columnStyles: {
					europe: { halign: 'center' },
					text: { halign: 'right', minCellWidth: 80 },
					s: { halign: 'center' },
				},
				columns: columnsBalance,
				body: [
					{
						text: 'Saldo Inicial',
						valor: 'R$ ' + this.initialValue,
					},
				],
			});

			doc = gerarTablePdf({
				doc,
				columns,
				body,
				columnStyles: {
					detail: { minCellWidth: 45 },
					date: { minCellWidth: 25 },
					type: { minCellWidth: 17 },
					value: { minCellWidth: 25 },
					effective_date: { minCellWidth: 25 },
				},
			});

			doc = gerarTablePdf({
				doc,
				showHead: 'never',
				columnStyles: {
					europe: { halign: 'center' },
					text: { halign: 'right', minCellWidth: 80 },
					s: { halign: 'center' },
				},
				columns: columnsBalance,
				body: [
					{
						text: 'Saldo Final',
						valor: 'R$ ' + this.finalValue,
					},
				],
			});

			doc = gerarDocInfo({
				doc,
				title: `Conta Universal  - ${process.env.VUE_APP_TITLE}`,
				orientacao,
			});

			salvarDocPdf({ doc, filename: 'conta_universal_' });
			this.loadingPdf = false;
			this.alldatas = null;
		},
		gerarExcel() {
			const adtStyle = {
				font: { bold: true },
				fill: {
					patternType: 'solid',
					fgColor: {
						rgb: 'fff5f5f5',
					},
					bgColor: {
						rgb: 'fff5f5f5',
					},
				},
				border: {
					top: {
						style: 'thin',
						color: { rgb: 'ffcecece' },
					},
					right: {
						style: 'thin',
						color: { rgb: 'ffcecece' },
					},
					bottom: {
						style: 'thin',
						color: { rgb: 'ffcecece' },
					},
					left: {
						style: 'thin',
						color: { rgb: 'ffcecece' },
					},
				},
			};

			let dataRows = [];
			this.transactionData.map(data => { 
				dataRows.push([
					{
						v: data.date || '',
						t: 's'
					},
					{
						v: data.origin_destiny || '',
						t: 's'
					},
					{
						v: data.type || '',
						t: 's'
					},
					{
						v: data.detail || '',
						t: 's'
					},
					data.type === 'Crédito' ? {
						v: data.value_excel || '',
						t: 'n',
						z: "R$ ##,##,##0.00",
					} : {
						v: -data.value_excel || '',
						t: 'n',
						z: "R$ ##,##,##0.00",
					},
					{
						v: data.effective_date || '',
						t: 's'
					},
				])
			});

			excelGenerator(
				'Conta Universal',
				'Conta Universal',
				'conta_universal',
				//before
				[
					[
						{
							v: `Conta Universal no Período de: ${format(
								Date.parse(this.dateStart),
								'dd/MM/yyyy'
							)} à ${format(
								Date.parse(this.dateEnd),
								'dd/MM/yyyy'
							)}`,
							t: 's',
							s: {
								alignment: { horizontal: 'center' },
								...adtStyle,
							},
						},
					],
					[],
					[
						{
							v: `Saldo Inicial: R$ ${this.initialValue}`,
							t: 's',
							s: {
								alignment: { horizontal: 'right' },
								...adtStyle,
							},
						},
					],
				],
				//after
				[
					[
						{
							v: `Saldo Final: R$ ${this.finalValue}`,
							t: 's',
							s: {
								alignment: { horizontal: 'right' },
								...adtStyle,
							},
						},
					],
				],
				//cols
				['Data',  'Origem / Destino', 'Tipo','Descrição', 'Valor', 'Data de Efetivação'],
				dataRows,
				true,
			);
			this.loadingExcel = false;
			dataRows = null;
		},
    }
};
</script>
